// extracted by mini-css-extract-plugin
export default {"backBtn":"hpJNBXuP17oHwKBPdl9u"};